var /**
 * TODO:
 * `Currencies` is a duplicate of `packages/state/src/Intl/IntlContext/IntlContext.tsx`
 *
 * We can't import these from the `state` package, because of cyclic dependency errors.
 * The best approach would be to create a separate package to host all the `Intl` configuration.
 */ Currencies;
(function(Currencies) {
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["USD"] = "USD";
    Currencies["SEK"] = "SEK";
    Currencies["DKK"] = "DKK";
})(Currencies || (Currencies = {}));
const CURRENCIES = Object.keys(Currencies);
const DEFAULT_CURRENCY = Currencies.EUR;
const DEFAULT_FORMAT = '--';
const calculateFractionDecimals = (value, isCentAmount, fixedDecimals)=>{
    // If fixedDecimals is true, always show 2 decimals
    if (fixedDecimals) {
        return 2;
    }
    // Calculate the remainder
    const remainder = value % (isCentAmount ? 100 : 1);
    // Return 0 fraction decimals if remainder is 0, otherwise return 2
    return remainder === 0 ? 0 : 2;
};
const formatPrice = ({ locale , value , currency , isCentAmount , fixedDecimals  })=>{
    if (value === undefined || isNaN(value)) {
        return DEFAULT_FORMAT;
    }
    var ref;
    // Only use supported currencies or fallback to default currency
    const priceCurrency = (ref = Currencies[currency || '']) !== null && ref !== void 0 ? ref : DEFAULT_CURRENCY;
    const number = isCentAmount ? value / 100 : value;
    const fractionDecimals = calculateFractionDecimals(value, isCentAmount, fixedDecimals);
    const price = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: priceCurrency,
        minimumFractionDigits: fractionDecimals,
        maximumFractionDigits: fractionDecimals
    }).format(number);
    return price;
};

export { CURRENCIES, formatPrice };
//# sourceMappingURL=format-price.js.map
